// decorators/arg.ts
import { BQLReflect } from "../metadata/reflect.js";
import { unwrapType, getArrayDepth } from "../metadata/types.js";
function Arg(name, type) {
  return (target, propertyName, parameterIndex) => {
    const argData = BQLReflect.getMetadata(target, propertyName + "_prop") || [];
    const unwrappedType = unwrapType(type);
    argData.push({ name, type: unwrappedType, arrayDepth: getArrayDepth(type), parameterIndex });
    BQLReflect.setMetadata(argData, target, propertyName + "_prop");
  };
}
export {
  Arg
};
